import { PropsWithChildren } from 'react';

export const IconChip = (props: PropsWithChildren<{}>) => {
  return <div className="p-[3px] bg-shale-750 rounded-full inline-block">{props.children}</div>;
};
